import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppWrapper from './AppWrapper';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
// Dev helper during development: expose compute helper
import attachPerfHelper from './devHelpers/perfTester';

import ErrorBoundary from './components/ErrorBoundary';

// Migração de dados para armazenamento nativo do Android
import { migrateFromLocalStorage, checkAppVersion } from './services/storageService';
import { initializeGoogleAuth } from './services/googleAuthService';

import { APP_VERSION } from './version';

// Função de inicialização segura
const initializeApp = async () => {
  try {
    // Executa migração ao iniciar (apenas no Android nativo, de forma transparente)
    await migrateFromLocalStorage();
  } catch (err) {
    console.error('Erro na migração de storage:', err);
  }

  try {
    // Verifica a versão do app e limpa dados antigos se necessário
    await checkAppVersion(APP_VERSION);
  } catch (err) {
    console.error('Erro na verificação de versão:', err);
  }

  try {
    // Inicializa plugin de autenticação Google
    initializeGoogleAuth();
  } catch (err) {
    console.error('Erro na inicialização do Google Auth:', err);
  }
};

// Captura ANTECIPADA do evento de instalação PWA.
// O beforeinstallprompt pode disparar ANTES do React montar,
// então capturamos aqui e guardamos em window para o App.js usar.
window.__pwaInstallPromptEvent = null;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.__pwaInstallPromptEvent = e;
  console.log('[PWA] beforeinstallprompt capturado antecipadamente no index.js');
});

// Dispara inicialização mas não bloqueia o render
initializeApp();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <AppWrapper />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// Configuração para PWA: Forçar atualização quando nova versão for detectada
serviceWorkerRegistration.register({
  onUpdate: accommodation => {
    // Quando uma atualização é encontrada (nova versão no servidor)
    const waitingServiceWorker = accommodation.waiting;

    if (waitingServiceWorker) {
      // Envia mensagem para o Service Worker pular a espera e ativar imediatamente
      waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });
    }
  },
});

// Listener para recarregar a página assim que o novo Service Worker assumir o controle
// Isso garante que o usuário sempre veja a versão mais nova após a atualização
let refreshing = false;
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!refreshing) {
      refreshing = true;
      window.location.reload();
    }
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Attach perf helper in dev only
if (process.env.NODE_ENV === 'development') {
  try { attachPerfHelper(); } catch (e) { /* ignore */ }
}
